import { replaceHtml,transformRangeToAbsolute,openSelfModel } from '../utils/util';
import { modelHTML } from './constant';
import sheetmanage from './sheetmanage';
import menuButton from './menuButton';
import {checkProtectionNotEnable} from './protection';
import { jfrefreshgrid } from '../global/refresh';
import locale from '../locale/locale';
import { setcellvalue } from '../global/setdata';
import currentSheet from "./common/currentSheet"; // 引入当前实例相关js
import createHtmlDom from "./common/createHtmlDom";

let isInitialCellFormatModel = false;

function initialCellFormatModelEvent(instance){
    const containerId = instance.getInstanceId();
	let Store = instance.getStore();
    const _locale = instance.locale();
    const local_cellFormat = _locale.cellFormat;
    let currentInstance = $(`#${containerId}`);

    currentInstance.find("#luckysheet-cellFormat-config-confirm").click(function(){
        let locked = currentInstance.find("#luckysheet-protection-check-locked").is(':checked');
        let hidden = currentInstance.find("#luckysheet-protection-check-hidden").is(':checked');
    
        locked = locked==true?1:0;
        hidden = hidden==true?1:0;

        let d = recycleSeletion(
            function(cell, r, c, data){
                if(cell==null){
                    instance.setdata.setcellvalue(r, c, data, {
                        lo:locked,
                        hi:hidden
                    });
                }
                else{
                    cell.lo = locked;
                    cell.hi = hidden;
                }
            },
            function(){
                alert(local_cellFormat.sheetDataIsNullAlert);
            },
            instance
        );

        instance.refresh.instance.refresh.jfrefreshgrid(d, undefined, undefined, false);

        currentInstance.find("#luckysheet-cellFormat-config").hide();
        currentInstance.find(`#luckysheet-modal-dialog-mask`).hide();
    });
}

function recycleSeletion(cycleFunction, dataIsNullFunction, instance){
    const containerId = instance.getInstanceId();
	let Store = instance.getStore();
    let currentInstance = $(`#${containerId}`);
    if(Store.luckysheet_select_save != null && Store.luckysheet_select_save.length > 0){
        let sheetFile = instance.sheetmanage.getSheetByIndex(), data=sheetFile.data;
        if(data!=null){
            
            for(let i=0;i<Store.luckysheet_select_save.length;i++){
                let selection = Store.luckysheet_select_save[i];
                let row = selection.row, column = selection.column;
                for(let r=row[0];r<=row[1];r++){
                    for(let c=column[0];c<=column[1];c++){
                        let cell;

                        let margeset = instance.menuButton.mergeborer(data, r, c);
                        if (!!margeset) {
                            // row = margeset.row[1];
                            // row_pre = margeset.row[0];
                            let row_index = margeset.row[2];
                            // row_index_ed = margeset.row[3];

                            // col = margeset.column[1];
                            // col_pre = margeset.column[0];
                            let col_index = margeset.column[2];
                            // col_index_ed = margeset.column[3];

                            cell = data[row_index][col_index];
                        }
                        else{
                            cell = data[r][c];
                        }

                        // if(cell.lo==null || cell.lo==1){
                        //     locked = true;
                        //     lockedCount++;
                        // }

                        // if(cell.hi==1){
                        //     hidden = true;
                        //     hiddenCount++;
                        // }

                        // count++;

                        cycleFunction(cell, r, c, data);
                    }
                }
            }
        }
        else{
            // locked = true;
            dataIsNullFunction();
        }

        return data;
    }
}

function initialCellFormatModel(instance){
    const containerId = instance.getInstanceId();
	let Store = instance.getStore();
    if(instance.cellFormat.isInitialCellFormatModel){
        return;
    }

    instance.cellFormat.isInitialCellFormatModel = true;
    const _locale = instance.locale();
    const local_cellFormat = _locale.cellFormat;
    const locale_button = _locale.button;

    //Password input initial
    let content = `<div class="luckysheet-cellFormat-menu-c">
        <div class="luckysheet-cellFormat-menu luckysheet-cellFormat-menu-active" id="luckysheet-cellFormat-protection">
            ${local_cellFormat.protection}
        </div>
    </div>
    <div id="luckysheet-cellFormat-protection-content" class="luckysheet-cellFormat-content">
        <div class="luckysheet-cellFormat-protection">
            <p>
                ${local_cellFormat.protectionTips}
            </p>
            <label for="luckysheet-protection-check-locked"><input id="luckysheet-protection-check-locked" name="luckysheet-protection-check-locked" type="checkbox">${local_cellFormat.locked}</label><span>部分选中</span>
            <br/>
            <label for="luckysheet-protection-check-hidden"><input id="luckysheet-protection-check-hidden" name="luckysheet-protection-check-hidden" type="checkbox">${local_cellFormat.hidden}</label><span>全部选中</span>
        </div>
    </div>`;
    instance.createHtmlDom.createDialog('luckysheet-cellFormat-config', content, containerId, local_cellFormat.cellFormatTitle, ()=>{}, false, false, true, '', '', '', false);

    initialCellFormatModelEvent(instance);
}

export function openCellFormatModel(container){
    let _this = this;
    const instance = _this.instance;
    const containerId = container || instance.getInstanceId();
    let Store = instance.getStore();
    let currentInstance = $(`#${containerId}`);
    initialCellFormatModel(instance);

    const _locale = instance.locale();
    const local_cellFormat = _locale.cellFormat;
    const locale_button = _locale.button;

    if(!instance.protection.checkProtectionNotEnable(Store.currentSheetIndex)){
        return;
    }

    let locked =false, hidden=false;
    let lockedCount=0, hiddenCount=0, count=0;
    if(Store.luckysheet_select_save != null && Store.luckysheet_select_save.length > 0){
        recycleSeletion(
            function(cell){
                // let cell = data[r][c];
                if(cell==null || cell.lo==null || cell.lo==1){
                    locked = true;
                    lockedCount++;
                }

                if(cell!=null && cell.hi==1){
                    hidden = true;
                    hiddenCount++;
                }

                count++;
            },
            function(){
                locked = true;
            },
            instance
        );
    }
    else{
        alert(local_cellFormat.selectionIsNullAlert);
        return;
    }

    let tipsLock="", tipshidden="";
    if(locked){
        tipsLock = lockedCount==count?local_cellFormat.tipsAll:local_cellFormat.tipsPart;
    }

    if(hidden){
        tipshidden = hiddenCount==count?local_cellFormat.tipsAll:local_cellFormat.tipsPart;
    }

    currentInstance.find("#luckysheet-protection-check-locked").prop('checked',locked).parent().next().html(tipsLock);
    currentInstance.find("#luckysheet-protection-check-hidden").prop('checked',hidden).parent().next().html(tipshidden);


    instance.util.openSelfModel("luckysheet-cellFormat-config", true, containerId);
}